/**
 * SUN-239: which name GST gives the vendor. Trade name (the firm) is the Vendor Name when the
 * registry has one; the legal name (the owner, for a proprietorship) is shown on its own line.
 * No trade name, or the same as the legal name (ignoring case and spacing) → legal name, no line.
 */
const norm = (s: string) => s.toUpperCase().replace(/\s+/g, ' ').trim();
const clean = (s?: string | null) => (typeof s === 'string' ? s.trim() : '');

export function legalNameUnder(name: string, legalName?: string | null): string | null {
  const legal = clean(legalName);
  if (!legal || !clean(name)) return null;
  return norm(legal) === norm(name) ? null : legal;
}

export function gstVendorName(d: { legalName?: string | null; tradeName?: string | null; companyName?: string | null }): { name: string | null; legalNameLine: string | null } {
  const legal = clean(d.legalName);
  const trade = clean(d.tradeName);
  const name = trade || legal || clean(d.companyName) || null;
  return { name, legalNameLine: trade && legal ? legalNameUnder(trade, legal) : null };
}
